"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTierCurrenciesResponseSchema = void 0;
const core_1 = require("../../../core");
exports.ListTierCurrenciesResponseSchema = (0, core_1.createUnsortedListResponseSchema)((0, core_1.StrictObject)({
    currency: core_1.CurrencySchema,
}));
